import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Tooltip } from 'primereact/tooltip';
import { components } from 'react-select';

import { useCaseListFilter } from 'hooks/useCaseListFilter';
import { LoaderComponent } from 'shared/LoaderComponent';

export default function CaseListDropDown(props) {
  const {
    isClient = false,
    selectFirstOption = false,
    caseOnly,
    disabled = false,
    onChange,
    placeholder = 'By Case',
    noOptionsMessage = 'No Cases Found',
    ref,
    paFilter,
    excludeFromLoading = false,
    is_case_list,
    ...rest
  } = props || {};
  const { initialCaseList, onSearchChange, isCasesLoading } = useCaseListFilter(
    isClient,
    caseOnly,
    paFilter,
    excludeFromLoading,
    is_case_list,
    true,
    true
  );
  const CustomDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <span className="pi pi-chevron-down" />
    </components.DropdownIndicator>
  );
  // Directly select the first valid option (skip the tip)
  const defaultOption = initialCaseList && initialCaseList.length > 1 ? initialCaseList[1] : null;

  // Manually trigger onChange with the default value after mount
  useEffect(() => {
    if (defaultOption && selectFirstOption && !rest?.value) {
      onChange(defaultOption); // Trigger onChange with the default value
    }
  }, [defaultOption]);

  const MenuListWithFooter = (p) => {
    const { children, selectProps } = p;
    return (
      <components.MenuList {...p}>
        {children}
        {selectProps.isLoading && <LoaderComponent />}
      </components.MenuList>
    );
  };

  const NoopLoadingMessage = () => null;

  return (
    <>
      <Tooltip target=".case-tooltip" position="top" />
      <div className="case-tooltip" data-pr-tooltip={rest?.value?.label || ''} data-pr-showdelay="500">
        <AsyncSelect
          {...rest}
          menuPortalTarget={document.body}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              borderRadius: 12,
              borderStyle: 'none',
              borderWidth: 'none',
              minWidth: 250,
            }),
            menuPortal: (baseStyles) => ({
              ...baseStyles,
              zIndex: 50000,
            }),
            ...rest?.styles,
          }}
          onChange={onChange}
          getOptionValue={(option) => option.id}
          isOptionDisabled={(option) => option.value === 'tip'}
          getOptionLabel={(option) => {
            if (isClient) {
              return initialCaseList?.find((item) => item?.id === option?.id)?.label;
            } else return option?.label;
          }}
          // placeholder="By Case"
          placeholder={placeholder}
          className="w-100 my-2"
          classNamePrefix="case-select"
          cacheOptions
          defaultOptions={initialCaseList}
          loadOptions={onSearchChange}
          // noOptionsMessage={() => 'No Cases Found'}
          noOptionsMessage={() => noOptionsMessage}
          isDisabled={disabled}
          isSearchable={!isClient}
          components={{
            DropdownIndicator: CustomDropdownIndicator,
            MenuList: MenuListWithFooter,
            LoadingMessage: NoopLoadingMessage,
          }}
          isLoading={isCasesLoading}
        />
        <input type="hidden" ref={ref} />
      </div>
    </>
  );
}
